define(['angular'], function(angular) {


    /**
     * @class TillPackService define tillPacks methods and conditions linked with till business rules.
     */
    function TillPackService(orderService) {
        var self = this;

        /**
         * Check if it is BT+ pack
         * @return {Boolean}
         */
        self.isBtouchPlusPack = function isBtouchPlusPack(tills) {
            if (
                typeof orderService.areTillsMixed(tills).tillType !== 'undefined' &&
                orderService.areTillsMixed(tills).tillType !== null
            ) {
                return orderService.areTillsMixed(tills).tillType === 'BT+';
            }
            else {
                return false;
            }
        };

        /**
         * Check if it is BT Pack
         * @return {Boolean}
         */
        self.isBtouchPack = function isBtouchPack(tills) {
            if (
                typeof orderService.areTillsMixed(tills).tillType !== 'undefined' &&
                orderService.areTillsMixed(tills).tillType !== null
            ) {
                return orderService.areTillsMixed(tills).tillType === 'BT';
            }
            else {
                return false;
            }
        };

        /**
         * Find if it is a new type of order with BTouch or Btouch+ tills (packs started in January 2017) or an older one with older tills.
         * @param  {Array}  tills
         * @param  {String}  type  order type
         * @return {Boolean}
         */
        self.is2017TillPack = function is2017TillPack(tills, type) {
            return (self.isBtouchPack(tills) || self.isBtouchPlusPack(tills)) && type === 'TRAD';
        };

        /**
         * Check if a Btouch pack is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasBtouchPack = function hasBtouchPack(tills) {
            return (
                self.hasTillPack(tills, 'PREMIUM') ||
                self.hasTillPack(tills, 'ESSENTIEL') ||
                self.hasTillPack(tills, 'BT') ||
                self.hasTillPack(tills, 'BT+')
            );
        };

        self.hasBtouchRefurbishedPack = function (tills) {
            return (
                self.hasTillPack(tills, 'PREMIUM_RECONDITIONNE')
            );
        };

        /**
         * Check if a Btouch plus pack is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasBtouchPlusPack = function hasBtouchPlusPack(tills) {
            return self.hasTillPack(tills, 'BT+');
        };

        /**
         * Check if a Bmoov pack is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasBmoovPack = function hasBmoovPack(tills) {
            return self.hasTillPack(tills, 'BM');
        };

        /**
         * Check if a Bmoov pack is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasBmoovPlusPack = function (tills) {
            return self.hasTillPack(tills, 'BM+');
        };


        /**
         * Check if a BSmart pack is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasBsmartPack = function hasBsmartPack(tills) {
            return (
                self.hasTillPack(tills, 'BS_PREMIUM') ||
                self.hasTillPack(tills, 'BS_ESSENTIEL') ||
                self.hasTillPack(tills, 'BS')
            );
        };

        self.hasPremiumBsmartPack = function(tills) {
            return  self.hasTillPack(tills, 'BS_PREMIUM');
        };

        /**
         * Check if a B Green pack is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasBgreenPack = function (tills) {
            return (
                self.hasTillPack(tills, 'BG_PREMIUM') ||
                self.hasTillPack(tills, 'BG_ESSENTIEL') ||
                self.hasTillPack(tills, 'BG')
            );
        };

        /**
         * Check if a B Wide pack is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasBwidePack = function (tills) {
            return (
                self.hasTillPack(tills, 'BW_PREMIUM') ||
                self.hasTillPack(tills, 'BW_ESSENTIEL') ||
                self.hasTillPack(tills, 'BW')
            );
        };

        /**
         * Check if a BSmart pack is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasBswiftPack = function (tills) {
            return (
                self.hasTillPack(tills, 'BSW_PREMIUM') ||
                self.hasTillPack(tills, 'BSW_ESSENTIEL') ||
                self.hasTillPack(tills, 'BSW')
            );
        };

        self.hasBCompactPack = (tills) => {
            return (
                self.hasTillPack(tills, 'BC_ESSENTIEL') ||
                self.hasTillPack(tills, 'BC')
            );
        }

        /**
         * Check if it is BG Pack
         * @return {Boolean}
         */
        self.isOnlyBGreenPack = (tills) => {
            return self.hasBgreenPack(tills) && !self.hasBsmartPack(tills) && !self.hasBtouchPack(tills) && !self.hasBtouchPlusPack(tills)
            && !self.hasBtouchRefurbishedPack(tills) && !self.hasBmoovPack(tills) && !self.hasBmoovPlusPack(tills) && !self.hasBswiftPack(tills);
        };

        /**
         * Check if it is BW Pack
         * @return {Boolean}
         */
        self.isOnlyBWidePack = (tills) => {
            return self.hasBwidePack(tills) && !self.hasBgreenPack(tills) && !self.hasBsmartPack(tills) && !self.hasBtouchPack(tills) && !self.hasBtouchPlusPack(tills)
                && !self.hasBtouchRefurbishedPack(tills) && !self.hasBmoovPack(tills) && !self.hasBmoovPlusPack(tills) && !self.hasBswiftPack(tills);
        };

        /**
         * Check if it is BS_PREMIUM Pack
         * @return {Boolean}
         */
        self.isOnlyBSmartPremiumPack = (tills) => {
            return self.hasPremiumBsmartPack(tills) && !self.hasBgreenPack(tills) && !self.hasBwidePack(tills) && !self.hasBtouchPack(tills) && !self.hasBtouchPlusPack(tills)
                && !self.hasBtouchRefurbishedPack(tills) && !self.hasBmoovPack(tills) && !self.hasBmoovPlusPack(tills) && !self.hasBswiftPack(tills);
        };

        /**
         * Check if a maintenance package is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasMaintenancePackage = function (tills) {
            return (
                self.hasTillPack(tills, 'FORFAIT')
            );
        };

        /**
         * Check if only maintenance package is in the tills list
         * @param  {Array}  tills
         * @return {Boolean}
         */
        self.hasOnlyMaintenancePackage = function (tills) {
            for (let till of tills) {
                if (till.tillType.code !== 'FORFAIT') {
                    return false;
                }
            }
            return true;
        };

        /**
         * Check if a given pack is in the tills list
         * @param  {Array}  tills
         * @param  {String}  tillTypeCode
         * @return {Boolean}
         */
        self.hasTillPack = function hasTillPack(tills, tillTypeCode) {
            for (let till of tills) {
                if (till.tillType.code === tillTypeCode) {
                    return true;
                }
            }
            return false;
        };

        self.getPricesByTillPack = function (order, prices, mixedTillPrices, tills) {
            if (order.isMultiStores) {
                tills['ESSENTIEL'].price = prices['ESSENTIEL'];
                tills['PREMIUM'].price = prices['PREMIUM'];
                tills['BS_ESSENTIEL'].price = prices['BS_ESSENTIEL'];
                tills['BS_PREMIUM'].price = prices['BS_PREMIUM'];
                tills['BG_ESSENTIEL'].price = prices['BG_ESSENTIEL'];
                tills['BG_PREMIUM'].price = prices['BG_PREMIUM'];
                tills['BM'].price = prices['BM'];
                tills['BM+'].price = prices['BM+'];
                tills['BSW_ESSENTIEL'].price = prices['BSW_ESSENTIEL'];
                tills['BSW_PREMIUM'].price = prices['BSW_PREMIUM'];
                tills['BW_ESSENTIEL'].price = prices['BW_ESSENTIEL'];
                tills['BW_PREMIUM'].price = prices['BW_PREMIUM'];
                tills['BC_ESSENTIEL'].price = prices['BC_ESSENTIEL'];
            }
            else if (tills.isMixed) {
                tills['ESSENTIEL'].price = mixedTillPrices['ESSENTIEL'];
                tills['PREMIUM'].price = mixedTillPrices['PREMIUM'];
                tills['BS_ESSENTIEL'].price = mixedTillPrices['BS_ESSENTIEL'];
                tills['BS_PREMIUM'].price = mixedTillPrices['BS_PREMIUM'];
                tills['BG_ESSENTIEL'].price = mixedTillPrices['BG_ESSENTIEL'];
                tills['BG_PREMIUM'].price = mixedTillPrices['BG_PREMIUM'];
                tills['BM'].price = mixedTillPrices['BM'];
                tills['BM+'].price = mixedTillPrices['BM+'];
                tills['BSW_ESSENTIEL'].price = mixedTillPrices['BSW_ESSENTIEL'];
                tills['BSW_PREMIUM'].price = mixedTillPrices['BSW_PREMIUM'];
                tills['BW_ESSENTIEL'].price = mixedTillPrices['BW_ESSENTIEL'];
                tills['BW_PREMIUM'].price = mixedTillPrices['BW_PREMIUM'];
                tills['BC_ESSENTIEL'].price = mixedTillPrices['BC_ESSENTIEL'];
            }
            else {
                tills['ESSENTIEL'].price = tills['ESSENTIEL'].nbTills > 0 ? order.prices.till : 0;
                tills['PREMIUM'].price = tills['PREMIUM'].nbTills > 0 ? order.prices.till : 0;
                tills['BS_ESSENTIEL'].price = tills['BS_ESSENTIEL'].nbTills > 0 ? order.prices.till : 0;
                tills['BS_PREMIUM'].price = tills['BS_PREMIUM'].nbTills > 0 ? order.prices.till : 0;
                tills['BG_ESSENTIEL'].price = tills['BG_ESSENTIEL'].nbTills > 0 ? order.prices.till : 0;
                tills['BG_PREMIUM'].price = tills['BG_PREMIUM'].nbTills > 0 ? order.prices.till : 0;
                tills['BM'].price = tills['BM'].nbTills > 0 ? order.prices.till : 0;
                tills['BM+'].price = tills['BM+'].nbTills > 0 ? order.prices.till : 0;
                tills['BSW_ESSENTIEL'].price = tills['BSW_ESSENTIEL'].nbTills > 0 ? order.prices.till : 0;
                tills['BSW_PREMIUM'].price = tills['BSW_PREMIUM'].nbTills > 0 ? order.prices.till : 0;
                tills['BW_ESSENTIEL'].price = tills['BW_ESSENTIEL'].nbTills > 0 ? order.prices.till : 0;
                tills['BW_PREMIUM'].price = tills['BW_PREMIUM'].nbTills > 0 ? order.prices.till : 0;
                tills['BC_ESSENTIEL'].price = tills['BC_ESSENTIEL'].nbTills > 0 ? order.prices.till : 0;
            }
            return tills;
        };

        self.getTillsByTillCode = function getTillsByTillCode(orderForm, order) {
            var tills = {};
            // Init tills[tillType] with each tillType found in the orderForm
            orderForm.tills.forEach(function(till) {
                if (tills[till.tillType.code] === undefined) {
                    tills[till.tillType.code] = {
                        nbTills: 0,
                        orders: [],
                        price: 0
                    };
                }
            });
            tills.isMixed = orderService.areTillsMixed(order.tills).isMixed;

            for (var i = 0; i < order.tills.length; i++) {
                tills[order.tills[i].tillType.code].orders.push(order.tills[i]);
                tills[order.tills[i].tillType.code].nbTills += order.tills[i].nbTills;
            }
            return tills;
        };

        self.getMixedPack = function getMixedPack(tills) {
            return {
                ESSENTIEL: tills['ESSENTIEL'].nbTills,
                PREMIUM: tills['PREMIUM'].nbTills,
                BS_ESSENTIEL: tills['BS_ESSENTIEL'].nbTills,
                BS_PREMIUM: tills['BS_PREMIUM'].nbTills,
                BG_ESSENTIEL: tills['BG_ESSENTIEL'].nbTills,
                BG_PREMIUM: tills['BG_PREMIUM'].nbTills,
                BM: tills['BM'].nbTills,
                'BM+' : tills['BM+'].nbTills,
                BSW_ESSENTIEL: tills['BSW_ESSENTIEL'].nbTills,
                BSW_PREMIUM: tills['BSW_PREMIUM'].nbTills,
                BW_ESSENTIEL: tills['BW_ESSENTIEL'].nbTills,
                BW_PREMIUM: tills['BW_PREMIUM'].nbTills,
                BC_ESSENTIEL: tills['BC_ESSENTIEL'].nbTills,
            };
        };

        return self;
    }

    TillPackService.$inject = ['orderService'];

    angular.module('app.bdc.common.tillPackService', []).factory('tillPackService', TillPackService);
});
